import { normalizeBaseUrl } from "shared-utils";
import { Api as LiteAgentApi } from "../generated/LiteAgentApi";
import config from "../config";
import { createAxiosRequestInterceptors } from "../axios/axios-interceptors";

const liteAgentApi = new LiteAgentApi({
  baseURL: normalizeBaseUrl(config.liteAgentApiUrl),
});

createAxiosRequestInterceptors(liteAgentApi.instance);

export default liteAgentApi;
